const HelpComponent = {
    templateUrl: '/help/help.tpl.html',
    controller: 'helpController',
    bindings: {
        topic: '@'
    }
};

angular.module('gw-um-header')
    .component('uiHelp', HelpComponent);
